import React from 'react';
import PropTypes from 'prop-types';
import { Headline } from 'react-orange-ui';
import styled from 'styled-components';

import WordingService from '../../services/WordingService';

import device from '../../helpers/breakpoints';
import { height, px2rem } from '../../orange-ui/styles/variables';

import Login from '../Login/Login';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: ${px2rem(height.header.medium)};
  
  @media ${device.mobile} {
     min-height: ${px2rem(height.header.small)};
  }
`;

const Head = ({ login }) => (
  <>
    <Wrapper>
        <Headline as="h1" id="app-title">
          {WordingService.getWording('title', 'appTitle')}
        </Headline>
    </Wrapper>
    {login && <Login login={login} />}
  </>
);

Head.propTypes = {
  login: PropTypes.string,
};

Head.defaultProps = {
  login: '',
};

export default Head;
